/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  TextInput,
  Button,
  FormGroup,
  ComposedModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  DropdownSkeleton,
  TextArea
} from 'carbon-components-react';
import moment from 'moment';
import SimpleReactValidator from 'simple-react-validator';
import { v4 as uuid } from 'uuid';
import _sortBy from 'lodash/sortBy';
import { switchDateFormat } from '../../helpers/jsonschemaform/customwidget/utils';
import { FindGHRSEmployer } from '../common/FindGHRSEmployer';
import { ComboBox } from '../../helpers/ComboBox';
import { showNotification } from '../../helpers/notification/BaseNotification';
import {
  DateFormat,
  entitiesLabels,
  getError,
  apioperation,
  CarType,
  GetCarTypeByCode,
} from '../../helpers/Constants';
import DateTimePicker from '../../helpers/DateTimePicker';
import AuditRepository from '../../helpers/api/AuditRepository';
import FindSaipemCompilers from '../common/FindSaipemCompilers';
import { CAROwnerManualInputModal } from '../functions/CAROwnerManualInputModal';

export default class AuditCARModal extends Component {
  auditCARModel = (props) => {
    if (props.isEditModal) {
      const { editModel } = props;

      return { ...editModel };
    }

    return {
      id: undefined, // guid
      idAudit: null, // guid
      idAnswer: null, // guid
      idStatus: 0, // int
      status: null,
      dueDate: null,
      idOwner: null, // idEmployer: null,  //guid
      owner: null,
      // {
      //   // employer: {
      //   // id: null, // guid
      //   // name: '',
      //   // surname: '',
      //   // email: '',
      // },
      idOwnerSaipem: null, // idEmployer: null,  //guid
      ownerSaipem: null,
      idGenericOwner: null,
      genericOwner: null,
      // {
      //   // employer: {
      //   // id: null, // guid
      //   // name: '',
      //   // surname: '',
      //   // email: '',
      // },
      findingsCode: null,
      findingsLevel1: null,
      findingsLevel2: null,
      findingsLevel3: null,
      findingsLevel4: null,
      inefficiency: null,
      referenceDocuments: null,
      type: null,
      carType: props.carType,
    };
  };

  constructor(props) {
    super(props);
    const owner = props.isEditModal
      ? props.editModel.owner || props.editModel.ownerSaipem || props.editModel.genericOwner
      : { id: null };
    this.validator = new SimpleReactValidator();
    this.state = {
      model: {
        ...this.auditCARModel(props),
      },
      owner,
      mode: props.mode || 0,
      appACTList1: null,
      appACTList2: null,
      appACTList3: null,
      appACTList4: null,
    };
    this.repository = new AuditRepository();
    this.renderCAR = this.renderCAR.bind(this);
  }

  async componentDidMount() {
    let types = null;
    let nccList1 = null;
    let nccList2 = null;
    let nccList3 = null;
    let nccList4 = null;
    try {
      types = (await this.repository.getNCClassificationTypes()).itemList;
      nccList1 = _sortBy(
        types.filter((el) => el.idParent == null && (el.inUse || this.state.model.findingsLevel1 == el.name)),
        'name'
      );
      if (this.state.model.findingsLevel1) {
        const idLevel1 = types.find((a) => a.name === this.state.model.findingsLevel1)?.id;
        nccList2 = _sortBy(
          types.filter((el) => el.idParent === idLevel1 && (el.inUse || this.state.model.findingsLevel2 == el.name)),
          'name'
        );
      }
      if (this.state.model.findingsLevel2) {
        const idLevel2 = types.find((a) => a.name === this.state.model.findingsLevel2)?.id;
        nccList3 = _sortBy(
          types.filter((el) => el.idParent === idLevel2 && (el.inUse || this.state.model.findingsLevel3 == el.name)),
          'name'
        );
      }
      if (this.state.model.findingsLevel3) {
        const idLevel3 = types.find((a) => a.name === this.state.model.findingsLevel3)?.id;
        nccList4 = _sortBy(
          types.filter((el) => el.idParent === idLevel3 && (el.inUse || this.state.model.findingsLevel4 == el.name)),
          'name'
        );
      }
      this.getLevel();
      this.setState({
        types,
        appACTList1: nccList1,
        appACTList2: nccList2,
        appACTList3: nccList3,
        appACTList4: nccList4,
      });
    } catch (error) {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.AuditNCClassificationType, apioperation.GET));
    }
  }
  
  
  getLevel = async () => {
    const levels = await this.repository.getLevels();
    const appTypes = levels.itemList.filter((lv) => lv.inUse || lv.name == this.state.model.type).map((l) => l.name);
    this.setState({
      appType: appTypes,
    });
  };
  getNCClassificationTypesByParent(idParent) {
    const { types } = this.state;
    return _sortBy(
      types.filter((el) => el.idParent === idParent),
      'name'
    );
  }

  handleChangeMode = (m) => {
    this.setState({ mode: m });
  };

  updateState = (inputName, inputValue, objName) => {
    const statusCopy = { ...this.state };
    statusCopy[objName][inputName] = inputValue;

    this.setState(statusCopy);
  };

  handleChangeModel = (el) => {
    const inputName = el.target.name;
    const inputValue = el.target.value;
    const objName = el.target.alt;
    this.updateState(inputName, inputValue, objName);
  };

  handleChangeDP = (value, text, event) => {
    const inputName = event.element.name;
    const objName = event.element.alt;

    if (value == null || value[0] == null) {
      this.updateState(inputName, null, objName);
      return;
    }

    let date = value[0];
    if (typeof date === 'object') {
      date = switchDateFormat(date, 'JSdate');
    }

    this.updateState(inputName, date, objName);
  };

  handleChangeDPInput = (event) => {
    if (event == null || event.target == null) return null;
    const inputName = event.target.name;
    const objName = event.target.alt;
    if (event.target.value == null) {
      return this.updateState(inputName, null, objName);
    }
    try {
      let date = event.target.value;
      const s = date.split('/');
      if (s.length < 3) return null;

      const dd = s[0];
      const mm = s[1];
      const yy = s[2];
      if (dd.length < 2 || mm.length < 2 || yy.length < 4) return null;

      date = `${yy}-${mm}-${dd}`;

      return this.updateState(inputName, date, objName);
    } catch (error) {
        console.error(error);
      return null;
    }
  };

  handleChangeCombo = (inputName, selectedItem, objName) => {
    const inputValue = selectedItem ? selectedItem.id : null;
    const statusCopy = { ...this.state };

    statusCopy[objName][inputName] = inputValue;

    this.setState(statusCopy);
  };

  handleChangeComboName = (inputName, selectedItem, objName) => {
    if (selectedItem != null) {
      selectedItem.id = selectedItem.name;
    }
    this.handleChangeCombo(inputName, selectedItem, objName);
  };

  handleChangeComboType = (inputName, selectedItem, objName) => {
    const inputValue = selectedItem ? selectedItem.name : null;

    const statusCopy = { ...this.state[objName] };
    statusCopy[inputName] = inputValue;

    if (inputName == 'findingsLevel1') {
      statusCopy.findingsLevel2 = null;
      statusCopy.findingsLevel3 = null;
      statusCopy.findingsLevel4 = null;
    }

    if (inputName == 'findingsLevel2') {
      statusCopy.findingsLevel3 = null;
      statusCopy.findingsLevel4 = null;
    }

    if (inputName == 'findingsLevel3') {
      statusCopy.findingsLevel4 = null;
    }

    this.setState({ [objName]: statusCopy }, () => {
      this.loadRelatedProperties(inputName, inputValue, selectedItem);
    });
  };

  loadRelatedProperties = (inputName, inputValue, selectedItem) => {
    if (inputName === 'findingsLevel1') {
      if (selectedItem) {
        this.setState({
          appACTList2: this.getNCClassificationTypesByParent(selectedItem.id).filter((c) => c.inUse),
        });
      } else {
        this.setState({
          appACTList2: null,
          appACTList3: null,
          appACTList4: null,
        });
      }
    }
    if (inputName === 'findingsLevel2') {
      if (selectedItem) {
        this.setState({
          appACTList3: this.getNCClassificationTypesByParent(selectedItem.id).filter((c) => c.inUse),
        });
      } else {
        this.setState({
          appACTList3: null,
          appACTList4: null,
        });
      }
    }
    if (inputName === 'findingsLevel3') {
      if (selectedItem) {
        this.setState({
          appACTList4: this.getNCClassificationTypesByParent(selectedItem.id).filter((c) => c.inUse),
        });
      } else {
        this.setState({
          appACTList4: null,
        });
      }
    }
  };

  setEmployer = (employer) => {
    if (employer && employer.id) {
      const statusCopy = { ...this.state.model };
      statusCopy.idOwner = employer.id;
      statusCopy.owner = employer;
      statusCopy.idOwnerSaipem = null;
      statusCopy.ownerSaipem = null;
      this.setState({ model: statusCopy, mode: 0, owner: employer });
    }
  };

  setSaipemOwner = (employer) => {
    if (employer && employer.id) {
      const statusCopy = { ...this.state.model };
      statusCopy.idOwnerSaipem = employer.id;
      statusCopy.ownerSaipem = employer;
      statusCopy.idOwner = null;
      statusCopy.owner = null;

      this.setState({ model: statusCopy, mode: 0, owner: employer });
    }
  };

  setGenericOwner = (genericOwner) => {
     if(genericOwner){
      const statusCopy = { ...this.state.model };
      statusCopy.idOwnerSaipem = null;
      statusCopy.ownerSaipem = null;
      statusCopy.idOwner = null;
      statusCopy.owner = null;
      if(genericOwner.id != null){
        statusCopy.idGenericOwner = genericOwner.id;
      }else{
        statusCopy.idGenericOwner = genericOwner.id = uuid();
      }
      statusCopy.genericOwner = genericOwner;
      this.setState({ model: statusCopy, mode: 0, owner: genericOwner });
    } 
	};

  save = () => {
    if (this.validator.allValid()) {
      const { model } = this.state;
      if (!this.props.isEditModal) {
        model.id = uuid();
      }
      this.props.save(model);
    } else {
      this.validator.showMessages();
      showNotification.warning(
        `${entitiesLabels.WARNING}`,
        `${entitiesLabels.FINDING} required fields are missing  `
      );
      this.forceUpdate();
    }
  };

  clearAttachment = () => ({
		id: null, // guid
		fileIdentifier: null,
		name: null,
		contentType: null,
		size: null,
		type: null,
	});

  onUploadFiles = (fileIdentifier, fileName, fileType, size) => {
    const attachment = { ...this.state.attachment };

    attachment.id = uuid();
    attachment.fileIdentifier = fileIdentifier.blobName;
    attachment.name = fileName;
    attachment.contentType = fileType;
    attachment.size = size;
    // attachment.filePath = file.localPath;

    this.setState({
      attachment: this.clearAttachment(),
    });

    try {
      if (attachment == null) return;
      // insert
      const oldattachment = this.state.model.attachment || [];

      const newItem = {
        id: uuid(), // guid

        idAttachment: attachment.id, // guid
        attachment,
      };

      const newattachment = oldattachment.concat([newItem]);
      this.setState({model: {...this.state.model, attachment: newattachment}})
    } catch (error) {
        console.error(error);
    }
  };

  onRemoveFile = (id) => {
    if (!id) return;
    const statusCopy = { ...this.state.model };
    statusCopy.attachment = statusCopy.attachment.filter((el) => el.id !== id);
    this.setState({model: statusCopy});
  };


  render() {
    return this.renderCAR();
  }

 renderCAR() {
    var diffduedate;
    if (this.state.model.dueDate != null) {
      diffduedate =
        !this.state.model.dueDate ||
        moment(this.state.model.dueDate).isSameOrAfter(moment(this.props.audit?.startDate), 'day');
    } else {
      diffduedate = true;
    }

    const dueDateIsValid =
      this.state.model.type != null && this.state.model.type.includes('Strength')
        ? true
        : this.state.model.dueDate != null;

    const validations = {
      inefficiency: this.validator.message('details', this.state.model.inefficiency, 'required'),
      referenceDocuments: this.validator.message(
        'referenceDocuments',
        this.state.model.referenceDocuments,
        'required'
      ),
      type: this.validator.message(
        'type',
        this.props.carType == CarType.NC.Code ? this.state.model.type : true,
        'required'
      ),

      findingsLevel1: this.validator.message(
        'Classification Type - List 1',
        this.state.model.findingsLevel1,
        'required'
      ),

      findingsLevel2: this.validator.message(
        'Classification Type - List 2',
        this.state.model.findingsLevel2,
        'required'
      ),

      findingsLevel3: this.validator.message(
        'Classification Type - List 3',
        this.state.model.findingsLevel3,
        'required'
      ),

      dueDate: this.validator.message(
        'dueDate',
        this.props.carType == CarType.NC.Code || this.props.carType == CarType.OBS.Code
          ? dueDateIsValid
          : true,
        'accepted'
      ),
      duedate: this.validator.message(
        'Due Date ',
        this.props.carType == CarType.NC.Code || this.props.carType == CarType.OBS.Code
          ? diffduedate
          : true,
        'accepted'
      ),
      idOwner: this.validator.message(
        'Owner',
        this.props.carType == CarType.NC.Code || this.props.carType == CarType.OBS.Code
          ? this.state.owner?.id
          : true,
        'required'
      ),
    };
    const modalHeader = {
      title: this.props.isEditModal
        ? `Edit ${GetCarTypeByCode(this.props.carType).Name}`
        : `Add new ${GetCarTypeByCode(this.props.carType).Name}` + (this.props.carType == CarType.SFI.Code ? ' (Not applicable for HSE Audit)' : ''),
      iconDescription: 'Close',
      buttonOnClick: () => this.props.toggleModal(false),
    };
    const { title, isOpenModal } = this.props;

    const selectedItemCombo = {
      idStatus: (this.props.appStatus || []).find(
        (el) => el.id == (this.state.model.idStatus > 0 ? this.state.model.idStatus : 1)
      ),
      type: this.state.model.type,
      findingsLevel1: (this.state.appACTList1 || []).find(
        (el) => el.name == this.state.model.findingsLevel1
      ),
      findingsLevel2: (this.state.appACTList2 || []).find(
        (el) => el.name == this.state.model.findingsLevel2
      ),
      findingsLevel3: (this.state.appACTList3 || []).find(
        (el) => el.name == this.state.model.findingsLevel3
      ),
      findingsLevel4: (this.state.appACTList4 || []).find(
        (el) => el.name == this.state.model.findingsLevel4
      ),
    };

    if (this.state.mode === 1) {
      return (
        <FindGHRSEmployer
          isOpenModal={isOpenModal}
          onCancel={() => this.handleChangeMode(0)}
          onOk={this.setEmployer}
        />
      );
    }
    if (this.state.mode === 2) {
      return (
        <FindSaipemCompilers
          isOpenModal={isOpenModal}
          url={`/audit/${this.props.audit.id}/car/compilers/`}
          onCancel={() => this.handleChangeMode(0)}
          onOk={this.setSaipemOwner}
        />
      );
    }
    if(this.state.mode === 3){
      return(
      <CAROwnerManualInputModal
        editModal={this.state.owner?.idGenericOwner != null}
        editModel={this.state.owner}
        onCancel={() => this.handleChangeMode(0)}
        onOk={this.setGenericOwner}
      />
      );
    }
    return (
      <ComposedModal
        className="light-modal"
        open={isOpenModal}
        danger="false"
        onClose={() => false}
      >
        <ModalHeader className="margin-modal" {...modalHeader}>
          {/* RITM0646764: rimosso titolo */}
          {/* <p>{title || ''}</p> */}
          {/* RITM0646764: FINE */}
          </ModalHeader>
        <ModalBody className="margin-modal">
          <div className="bx--grid--full-width">
            <div className="bx--row">
              <div className="bx--col-lg-12 bx--col-md-12">
                <FormGroup legendText="Details*">
                  <TextArea
                    maxLength={5000}
                    id="inefficiency"
                    placeholder=""
                    value={this.state.model.inefficiency || ''}
                    onChange={(el) => this.updateState('inefficiency', el.target.value, 'model')}
                    hideLabel
                    labelText=""
                    light
                    rows={4}
                    cols={225}
                    invalid={validations.inefficiency != null}
                  />
                  {validations.inefficiency}
                </FormGroup>
              </div>
            </div>
            <div className="bx--row">
              <div className="bx--col-lg-12 bx--col-md-12">
                <FormGroup legendText="Reference Documents*">
                  <TextArea
                    maxLength={5000}
                    id="referenceDocuments"
                    placeholder=""
                    value={this.state.model.referenceDocuments || ''}
                    onChange={(el) =>
                      this.updateState('referenceDocuments', el.target.value, 'model')
                    }
                    hideLabel
                    labelText=""
                    light
                    rows={4}
                    cols={225}
                    invalid={validations.referenceDocuments != null}
                  />
                  {validations.referenceDocuments}
                </FormGroup>
              </div>
            </div>

            <div className="bx--row">
              <div className="bx--col-lg-6 bx--col-md-6">
                <FormGroup legendText="Project Finding Code">
                  <TextInput
                    id="findingCode"
                    placeholder=""
                    value={this.state.model.findingCode || ''}
                    labelText=""
                    onChange={(el) =>
                      this.updateState('findingCode', el.target.value, 'model')
                    }
                    type="text"
                  />
                </FormGroup>
              </div>
              {this.props.carType == CarType.NC.Code ? (
                <div className="bx--col-md-4 bx--col-lg-6">
                  <FormGroup legendText="Finding/NC Level *">
                    {this.state.appType == null ? (
                      <DropdownSkeleton />
                    ) : (
                      <ComboBox
                        id="type"
                        placeholder="Select"
                        name="type"
                        alt="model"
                        onChange={this.updateState}
                        itemToString={(item) => item || ''}
                        initialSelectedItem={selectedItemCombo.type}
                        items={this.state.appType}
                        invalid={validations.type != null}
                      />
                    )}
                    {validations.type}
                  </FormGroup>
                </div>
              ) : (
                ''
              )}
            </div>
            <div className="bx--row">
              <div className="bx--col-lg-6 bx--col-md-4">
                <FormGroup legendText="Classification Type - List 1 *">
                  {this.state.appACTList1 == null ? (
                    <DropdownSkeleton />
                  ) : (
                    <ComboBox
                      id="findingsLevel1"
                      placeholder="Select"
                      name="findingsLevel1"
                      alt="model"
                      onChange={this.handleChangeComboType}
                      itemToString={(item) => (item ? item.name : '')}
                      initialSelectedItem={selectedItemCombo.findingsLevel1}
                      items={this.state.appACTList1}
                      direction={
                        this.props.carType == CarType.Strength.Code ||
                        this.props.carType == CarType.SFI.Code
                          ? 'top'
                          : 'bottom'
                      }
                    />
                  )}
                  {validations.findingsLevel1}
                </FormGroup>
              </div>
              <div className="bx--col-lg-6 bx--col-md-4">
                <FormGroup legendText="Classification Type - List 2 *">
                  <ComboBox
                    id="findingsLevel2"
                    placeholder="Select"
                    name="findingsLevel2"
                    alt="model"
                    onChange={this.handleChangeComboType}
                    itemToString={(item) => (item ? item.name : '')}
                    initialSelectedItem={selectedItemCombo.findingsLevel2}
                    items={this.state.appACTList2}
                    disabled={this.state.appACTList2 == null}
                    key={this.state.appACTList2}
                    direction={
                      this.props.carType == CarType.Strength.Code ||
                      this.props.carType == CarType.SFI.Code
                        ? 'top'
                        : 'bottom'
                    }
                  />
                  {validations.findingsLevel2}
                </FormGroup>
              </div>
            </div>
            <div className="bx--row">
              <div className="bx--col-lg-6 bx--col-md-4">
                <FormGroup legendText="Classification Type - List 3 *">
                  <ComboBox
                    id="findingsLevel3"
                    placeholder="Select"
                    name="findingsLevel3"
                    alt="model"
                    onChange={this.handleChangeComboType}
                    itemToString={(item) => (item ? item.name : '')}
                    initialSelectedItem={selectedItemCombo.findingsLevel3}
                    items={this.state.appACTList3}
                    disabled={this.state.appACTList3 == null}
                    key={this.state.appACTList3}
                    direction={
                      this.props.carType == CarType.Strength.Code ||
                      this.props.carType == CarType.SFI.Code
                        ? 'top'
                        : 'bottom'
                    }
                  />
                  {validations.findingsLevel3}
                </FormGroup>
              </div>
              <div className="bx--col-lg-6 bx--col-md-4">
                <FormGroup legendText="Classification Type - List 4">
                  <ComboBox
                    id="findingsLevel4"
                    placeholder="Select"
                    name="findingsLevel4"
                    alt="model"
                    onChange={this.handleChangeComboName}
                    itemToString={(item) => (item ? item.name : '')}
                    initialSelectedItem={selectedItemCombo.findingsLevel4}
                    items={this.state.appACTList4}
                    disabled={this.state.appACTList4 == null}
                    key={this.state.appACTList4}
                    direction={
                      this.props.carType == CarType.Strength.Code ||
                      this.props.carType == CarType.SFI.Code
                        ? 'top'
                        : 'bottom'
                    }
                  />
                </FormGroup>
              </div>
            </div>

            {this.props.carType == CarType.NC.Code || this.props.carType == CarType.OBS.Code ? (
              <div className="bx--row">
                <div className="bx--col-lg-6 bx--col-md-4">
                  <FormGroup
                    legendText={
                      this.state.model.type != null && this.state.model.type.includes('Strength')
                        ? 'Due Date'
                        : 'Due Date*'
                    }
                  >
                    <DateTimePicker
                      value={this.state.model.dueDate}
                      type="date"
                      placeholder={DateFormat}
                      name="dueDate"
                      alt="model"
                      invalid={validations.dueDate != null}
                      onChange={this.updateState}
                    />

                    {validations.dueDate}
                    {validations.duedate ? (
                      <div className="srv-validation-message">
                        {' '}
                        due dates less than the audit start date{' '}
                      </div>
                    ) : null}
                  </FormGroup>
                </div>

                {/* <div className="bx--col-md-6 bx--col-lg-6">
                <FormGroup legendText="Actual date of completion of CAR">
                  {!this.state.model ? (
                    <DatePickerSkeleton />
                  ) : (
                    <DateTimePicker
                      value={this.state.model?.actualDateCompletition}
                      type="date"
                      disableFutureDate
                      placeholder={DateFormat}
                      name="actualDateCompletition"
                      alt="model"
                      onChange={this.updateState}
                    />
                )}
                </FormGroup>
            </div> */}

                <div className="bx--col-lg-6 bx--col-md-8">
                  <FormGroup legendText="Find Owner on GHRS or Saipem*">
                    <div className="bx--row two-button-center">
                      <div className="bx--col-lg-6 bx--col-md-6">
                        <Button
                          kind="primary"
                          className="bx--col"
                          onClick={() => this.handleChangeMode(1)}
                        >
                          GHRS research
                        </Button>
                      </div>
                      <div className="bx--col-lg-6 bx--col-md-6">
                        <Button
                          kind="primary"
                          className="bx--col"
                          onClick={() => this.handleChangeMode(2)}
                        >
                          Saipem research
                        </Button>
                        { 
                        <Button
                          kind="primary"
                          className="bx--col"
                          onClick={() => this.handleChangeMode(3)}
                        >
                          Manual input
                        </Button>
                        } 
                      </div>
                    </div>
                    {validations.idOwner}
                  </FormGroup>
                </div>
                <div className="bx--col-lg-6 bx--col-md-4">
                  <FormGroup legendText="Owner Name">
                    <TextInput
                      id="txt-name"
                      name="txt-name"
                      placeholder=""
                      value={this.state.owner?.name || ''}
                      type="text"
                      hideLabel
                      labelText=""
                      disabled
                    />
                  </FormGroup>
                </div>
                <div className="bx--col-lg-6 bx--col-md-4">
                  <FormGroup legendText="Owner Surname">
                    <TextInput
                      id="txt-surname"
                      name="txt-surname"
                      placeholder=""
                      value={this.state.owner?.surname || ''}
                      // onChange={this.handleChangeModel}
                      type="text"
                      hideLabel
                      labelText=""
                      disabled
                    />
                  </FormGroup>
                </div>
                <div className="bx--col-lg-6 bx--col-md-4">
                  <FormGroup legendText="Owner Badge Number or email">
                    <TextInput
                      id="txt-badgeNumber"
                      name="txt-badgeNumber"
                      placeholder=""
                      value={this.state.owner?.ghrS_ID || this.state.owner?.email || ''}
                      // onChange={this.handleChangeModel}
                      type="text"
                      hideLabel
                      labelText=""
                      disabled
                    />
                  </FormGroup>
                </div>
              </div>
            ) : (
              ''
            )}

            {/* <div className="bx--row">
              <AttachmentTable
                storagePath="audit"
                model={this.state.model}
                items={this.state.model?.attachment}
                apiDownloadUrl={`/audit/${this.state.model?.idAudit}/answer/${this.state.model?.idAnswer}/car/${this.state.model?.id}/attachment/`}
                onUploadFIle={this.onUploadFiles}
                onDeleteFile={this.onRemoveFile}
              />
            </div> */}

          </div>
        </ModalBody>
        <ModalFooter>
          <Button kind="secondary" onClick={() => this.props.toggleModal(false)}>
            Cancel
          </Button>
          <Button kind="primary" onClick={() => this.save()}>
            Save
          </Button>
        </ModalFooter>
      </ComposedModal>
    );
  }
}

AuditCARModal.propTypes = {
  save: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired,
  isEditModal: PropTypes.bool,
  isOpenModal: PropTypes.bool,
  mode: PropTypes.number,
  title: PropTypes.string,
  appStatus: PropTypes.array,
};
